import { useState } from 'react'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { crm2Api, useCrm2Write, type Contact } from './api'
import { Field, PHONE_HINT, PHONE_PLACEHOLDER } from './shared'

/** Name, title, email and contact number, edited in place. The number is checked and tidied when saved. */
export function EditContact({ c, onDone }: { c: Contact; onDone: () => void }) {
  const [f, setF] = useState({ name: c.name, title: c.title ?? '', email: c.email ?? '', phone: c.phone ?? '' })
  const save = useCrm2Write(() => crm2Api.patchContact(c.id, { name: f.name.trim(), title: f.title.trim() || null, email: f.email.trim() || null, phone: f.phone.trim() || null }), () => 'Saved')
  return (
    <div className="grid gap-2">
      <Field label="Name">
        <Input value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} />
      </Field>
      <Field label="Title">
        <Input value={f.title} onChange={(e) => setF({ ...f, title: e.target.value })} />
      </Field>
      <Field label="Email">
        <Input type="email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} />
      </Field>
      <Field label="Contact number" hint={PHONE_HINT}>
        <Input type="tel" value={f.phone} onChange={(e) => setF({ ...f, phone: e.target.value })} placeholder={PHONE_PLACEHOLDER} />
      </Field>
      <div className="flex gap-2">
        <Button size="sm" disabled={!f.name.trim() || save.isPending} onClick={() => save.mutate(undefined, { onSuccess: onDone })}>
          Save
        </Button>
        <Button size="sm" variant="ghost" onClick={onDone}>
          Cancel
        </Button>
      </div>
    </div>
  )
}
